import { render } from "./eventLeague_view.vue?vue&type=template&id=34709e0c"
import script from "./eventLeague_view.vue?vue&type=script&lang=js"
export * from "./eventLeague_view.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__